const FetchResults = (formdata) => {
	var myHeaders = new Headers();

	myHeaders.append(
		"Authorization",
		"Basic YWRtaW46b2xkcnNwY2Fuc3c=",
	);
	myHeaders.append("Cookie", "PHPSESSID=3b2afad1eec1959f8646a53971bd5121");

	var requestOptions = {
		method: "POST",
		headers: myHeaders,
		body: formdata,
		redirect: "follow",
	};

	return fetch(
		"https://staging.rspcansw.org.au/wp-json/competible/results",
		requestOptions,
	)
		.then((response) => {
			if (!response.ok) {
				throw new Error(
					`This is an HTTP error: The status is ${response.status}`,
				);
			}
			return response.json();
		})
		.then((result) => {
			return result;
		})
		.catch((error) => console.log("error", error));
};

export default FetchResults;
